const metadataStandards = {
  id: "metadataStandards",
  label: "Metadata Standards",
  endpoint: "metadata_standards",
  columnConfig: [
    {
      field: "name",
      headerName: "Metadata Standard",
      width: 250,
      description: "Metadata Standard",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default metadataStandards;
